import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

interface Props {
  codigoRegional365: string;
  enabled?: boolean;
}

export function useListarProdutos(props: Props) {
  const fetchData = async () => {
    const LISTAR_PRODUTOS = `locais/mobile/empreendimentos2/v1?cc=${props.codigoRegional365}`;
    const response = await instance.get(LISTAR_PRODUTOS);
    return response?.data?.data || [];
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: ["listar_produtos", props.codigoRegional365],
    enabled: (props.enabled ?? true) && !!props.codigoRegional365,
    refetchOnWindowFocus: false,
  });

  return query;
}
